import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
import { InMemoryCache } from '../InMemoryCache';
import identity from 'transmute/identity';
const fetchHiddenPropertyEnumOptions = (objectTypeId, httpClient) => getFrameworkDataSchemasClient({
  httpClient
}).then(client => client.propertyMetadata.get({
  frameworkTypeIdentifier: objectTypeId,
  appSettingName: 'propertyOptionSettings'
}));
export const makeHiddenPropertyEnumOptionsCache = () => new InMemoryCache('HiddenPropertyEnumOptionsCache', identity, ({
  httpClient
}) => objectTypeId => fetchHiddenPropertyEnumOptions(objectTypeId, httpClient));